import { render, staticRenderFns } from "./VariationTextSelector.vue?vue&type=template&id=07068d07&scoped=true"
import script from "./VariationTextSelector.vue?vue&type=script&lang=js"
export * from "./VariationTextSelector.vue?vue&type=script&lang=js"
import style0 from "./VariationTextSelector.vue?vue&type=style&index=0&id=07068d07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07068d07",
  null
  
)

export default component.exports